import { mapState, mapActions } from '@/store/helpers';

import { mapState as rootMapState } from 'pinia';

import { usePageStore } from '@/store';

import { defineAsyncComponent } from 'vue';
import { colorBlock } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import * as TYPES from './_store/types';

import useStore from './_store';
import spaceMixin from '@/modules/space-mixin';
import styleMixin from '@/modules/color-mixin';

export default {
    i18next: {
        ns: 'md-team'
    },
    _getUseStore: useStore,
    asyncData: mapAsyncData(asyncData),
    mixins: [spaceMixin(), styleMixin()],
    data: function() {
        return {
            agentIds: '',
            shuffleAgents: false, // Whether to sort randomly
            title: '',
            bgType: 'color',
            bgColor: '',
            agentBgColor: '',
            socialMediaBgColor: '',
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            queryAll: false,
            titleSize: '',
            // companyInfo: null, //  Compatible with custom code
            ...colorBlock,
            showAllAgents: false,
            inputValue: '',
            moreText: '',
            lessText: '',
            pageNum: 1,
            pageSize: 24,
            useExternalUrl: false,
            autoSort: false,
            showSearchBar: false,
            customAgents: [],
            fullColumn: false,
            searchParams: {}, // Without a store, the page is initialized with asyncData!!!
            enableBookAppointment: false
        };
    },
    components: {
        Pagination: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination"*/ '@/components/pagination/index.vue'
            ))
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            agentCreator: store => store.page?.agentCreator
        }),
        ...mapState({
            total: store => store.total,
            allTotal: store => store.allTotal,
            agents: store => store.agents,
            totalCount: store => store.totalCount,
        }),
        agent({ agents, agentCreator, agentId = 0 }) {
            if (agentId == 0 && agentCreator) {
                return agentCreator;
            }
            let selectAgent = agents.find(item => item.id === agentId)
            return selectAgent || agentCreator || agents[0] || {};
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        mobile() {
            return this.isMobileSize;
        },
        detailUrlTarget({ page }) {
            return page.agentDetailOpenStyle || '_self';
        },
        licenseName({ page }) {
            return page.licenseName;
        },
        useBgSrc({ bgImgOpt }) {
            function normalImg(img) {
                if (typeof img === 'string' && img) {
                    return img;
                } else if (typeof img === 'object') {
                    return img.imgUrl;
                }
            }
            let { src, mobileSrc } = bgImgOpt;
            if (!this.isMobileSize) {
                return normalImg(src) || normalImg(mobileSrc);
            } else {
                return normalImg(mobileSrc) || normalImg(src);
            }
        },
        bgImgStyle({ bgType, useBgSrc }) {
            let ret = {};
            if (bgType === 'img') {
                ret.background = `url(${useBgSrc}) no-repeat center/cover`;
            }
            return ret;
        },
        fmtTitle({ title, totalCount }) {
            if (/{ *Count *}/.test(title)) {
                return title.replace(/{ *Count *}/g, totalCount);
            } else {
                return title;
            }
        }
    },
    methods: {
        ...mapActions({
            fetchAgents: TYPES.FETCH_AGENTS,
            fetchAgentInfo: TYPES.FETCH_AGENT_INFO
        }),
        getAgentInfo() {
            // use cms to fetch data
            this.fetchAgentInfo(this.agentId, this.useExternalUrl);
        },
        getAgentHeadShots(agent) {
            return agent.headShots?.['photoOneByOne'] || agent.headShots?.['photoThreeByFour'] || agent.headShots?.['photoFiveByThree'] || agent.image || ''
        },
        gotoLink(link) {
            window.open(link, this.detailUrlTarget);
        },
        agentAlt(agent) {
            return agent.fullName;
        },
        setSearchParams(params) {
            Object.assign(this.searchParams, params);
        },
        async getAgents(_t) {
            this.fetchAgents(this, _t);
        },
        pageChange(data) {
            this.pageNum = data.page || 1;
            this.getAgents();
            this.$nextTick(() => {
                if (this.$el) {
                    this.$el.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
    },
    provide() {
        return {
            useExternalUrl: this.useExternalUrl
        };
    }
};
